<template>
    <page-main class="wrapper--page intro">

        <div ref="wrapper" class="intro__wrap text--center" data-flex="row keep center">
            <IntroSlide 
                view="home" 
                :ready="false" 
            />
        </div>

        <div class="intro__bg">
            <!-- <video ref="video" loop muted preload playsinline :poster="poster">
                <source :src="video" type="video/mp4">
            </video> -->
            <SlideLines />
        </div>

    </page-main>
</template>

<script>
import { focusables } from '@/mixins/focusables'
import SlideLines from '@/components/Slide/SlideLines'

import IntroSlide from './IntroSlide'

export default {
    name: 'Intro',
    components: {
        SlideLines,
        IntroSlide,
    },
    mixins: [
        focusables,
    ],
    data() {
        return {
            // started: false,
            // poster: require('@/assets/img/poster.png'),
            // video: require('@/assets/intro.mp4')
        }
    },
    destroyed() {
        // this.$root.$off('goto-form')
        this.rootClass('remove')
    },
    created() {
        // this.$root.$on('goto-form', () => {
        //     setTimeout( () => {
        //         this.started = !this.started
        //         this.$router.push({ hash: 'hello' })
        //     })
        // })

        // if ( !this.started && this.$route.hash.includes('hello') ) {
        //     this.$router.replace('/')
        // }

        this.focusables().rm( this.$refs.wrapper, `button, input` )
    },
    activated() {
        this.rootClass('rm')
        // this.$refs.video.play()
    },
    // watch: {
    //     '$route' (to/*, from*/) {
    //         setTimeout( () => {
    //             this.started = !to.hash ? false : true

    //             const [ first, second ] = this.$refs.wrapper.children

    //             this.focusables().rm( this.$refs.wrapper, `button, input` )
    //             this.focusables().add( !to.hash ? first : second, `button, input` )

    //         }, 0)
    //     }
    // }
}
</script>
